import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'footer',
    templateUrl: 'footer.template.html',
    styleUrls: ['footer.component.css']
})
export class FooterComponent {
  public version: string = environment.version
}
